import { lazy, Suspense } from 'react'
import { Route, Routes } from 'react-router-dom'
import BaseLayout from './layouts'

const App: React.FC = () => {
  const LazyHome = lazy(() => import('@/pages/home/index'))
  const LazyPlan = lazy(() => import('@/pages/plan/index'))

  return (
    <BaseLayout>
      <Routes>
        <Route path="/" element={<Suspense fallback={<div></div>}><LazyHome /></Suspense>} />
        <Route path="/plan" element={<Suspense fallback={<div></div>}><LazyPlan /></Suspense>} />
      </Routes>
    </BaseLayout>
  )
}

export default App
